import { useNavigate, useLocation } from 'react-router-dom';
import { CardButton } from '../../Buttons/CardButton';
import { safePathName } from '../../../../utils/helpers';

export type FullPageCTARendererProps = {
  data: object;
  value: string;
  valueFormatted: string;
  onClick?: () => void;
  // Destination override for rows whose detail does not live at this page's path plus the row id.
  path?: string;
};

export function FullPageCTARenderer({ data, value, valueFormatted, onClick, path }: FullPageCTARendererProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const valueString: string = valueFormatted || value;
  const currentId = data['id' as keyof typeof data];

  const handleDetailClick = () => {
    const safePath = safePathName(location.pathname);
    // The override runs through the same sanitizer as the default: it is a public prop, so the
    // guarantee belongs here rather than resting on every caller building it carefully.
    navigate(path ? safePathName(path) : `${safePath}/${encodeURIComponent(currentId)}`);
    if (onClick) onClick();
  };

  return (
    <div className="mt-3">
      <div className="desc-wrap">{valueString}</div>
      <CardButton
        data-testid="full-page-cta-button"
        data-cy="full-page-cta-button"
        onClick={handleDetailClick}
        className="h-4"
        icon="details"
      />
    </div>
  );
}
